import React, { useEffect, useState } from 'react'
import ContainerDashboard from '../../components/layouts/ContainerDashboard'
import secureLocalStorage from 'react-secure-storage'
import { axiosInstance } from '../Config'
import Loader from '../Loader'
import CalendarTwo from './CalendarTwo'
import { useNavigate } from 'react-router-dom'

const CalendarIndex = () => {

    const [allSession, setAllSession] = useState([])
    const users  = secureLocalStorage.getItem("credentials");
    const [loading, setLoading] = useState(false)

    const navigate = useNavigate()

    useEffect(() => {
        window.scrollTo(0, 0)
        getSessionsInfo()
    }, [])

    function getSessionsInfo() {
        setLoading(true)
        axiosInstance.post(`get-usrlesson` , {
            instructorid : users.id,
            type : 0
        } , {
            headers : {
                Authorization : `Bearer ${users.token}`
            }
        })
            .then(res => {
                // Reverse the newData array
                const reversedData = res.data.lesson.filter((item) => item.status !== 0).reverse(); // Make sure not to mutate the original array
                // Set reversed data to both states

                setAllSession(reversedData);  
            })
            .catch((err) => console.log(err))
            .finally(() => {
                setLoading(false)
            })
    }

    return (
        <>
            {loading && <Loader />}
            <ContainerDashboard title="Calendar" description="Everything here">
                <section className="ps-dashboards" id="homepages">
                    <div className="row justify-content-between align-items-center">

                        <div className="col-md-12 ">
                            <div className="p-4 py-5 bg-gradientt rounded-4">
                                <div className='text-end mb-4'>
                                    <button type="button" onClick={() => navigate(-1)} className="button btn-black text-white ">
                                        <i className="icon-arrow-left me-3 fs-5"></i>back
                                    </button>
                                </div>
                                <CalendarTwo session_data={allSession} />
                            </div>

                        </div>
                    </div>
                </section>
            </ContainerDashboard>
        </>
    )
}

export default CalendarIndex